module.exports = __webpack_public_path__ + "static/media/home_screen.44f67e0f.png";